import types from '@/vuex/administracao/edicao-tipo-documental/mutations-types'

const mutations = {
  [types.SET_LISTA_TIPOS_DOCUMENTAIS]: (state, payload) => {
    state.listaTiposDocumentais = payload.listaTiposDocumentais
  },
  [types.SET_TIPO_SELECIONADO]: (state, payload) => {
    state.idTipoSelecionado = payload.idTipoSelecionado
  },
  [types.SET_PROPRIEDADES]: (state, payload) => {
    state.listaTiposDocumentais.forEach(function (o) {
      if (o.id === payload.idTipoDocumento) {
        if (typeof payload.propriedade.ativo !== 'undefined') {
          o.ativo = payload.propriedade.ativo
        }
        if (typeof payload.propriedade.geraCapa !== 'undefined') {
          o.geraCapa = payload.propriedade.geraCapa
        }
        if (typeof payload.propriedade.notificaInteressadoTramitacao !== 'undefined') {
          o.notificaInteressadoTramitacao = payload.propriedade.notificaInteressadoTramitacao
        }
        if (typeof payload.propriedade.integrado !== 'undefined') {
          o.integrado = payload.propriedade.integrado
        }
        if (typeof payload.propriedade.urlDocumentacao !== 'undefined') {
          o.urlDocumentacao = payload.propriedade.urlDocumentacao
        }
        if (typeof payload.propriedade.consideradoProcessoNaAnexacao !== 'undefined') {
          o.consideradoProcessoNaAnexacao = payload.propriedade.consideradoProcessoNaAnexacao
        }
        if (typeof payload.propriedade.observacao !== 'undefined') {
          o.observacao = payload.propriedade.observacao
        }
      }
    })
  }
}
export default mutations
